import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

const PENDING_GALLERY_QR_VISIT_KEY = 'suarte.pendingGalleryQrVisit';

function normalizeToken(token) {
  return typeof token === 'string' ? token.trim() : '';
}

export async function redeemGalleryQrVisit(token) {
  const normalizedToken = normalizeToken(token);
  if (!normalizedToken) {
    throw new Error('A gallery QR token is required.');
  }

  const { response, data } = await fetchWrapper.post(
    `${config.apis.api.url}/q/gallery/${encodeURIComponent(normalizedToken)}/visit`,
    { injectToken: true, body: {} },
  );

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to save this gallery visit.');
  }
}

export async function getPublicGalleryQrVisits(username, { cursor = null, limit = 24 } = {}) {
  const normalizedUsername = typeof username === 'string' ? username.trim() : '';
  if (!normalizedUsername) {
    return { data: [], next_cursor: null };
  }

  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) {
    params.set('cursor', cursor);
  }

  const { response, data } = await fetchWrapper.get(
    `${config.apis.api.url}/user/public/${encodeURIComponent(normalizedUsername)}/gallery-visits/?${params.toString()}`,
    { contentType: false },
  );

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to load visited galleries.');
  }

  return data || { data: [], next_cursor: null };
}

export function getPendingGalleryQrVisit() {
  try {
    return normalizeToken(window.sessionStorage.getItem(PENDING_GALLERY_QR_VISIT_KEY));
  } catch (_) {
    return '';
  }
}

export function setPendingGalleryQrVisit(token) {
  const normalizedToken = normalizeToken(token);
  try {
    if (normalizedToken) {
      window.sessionStorage.setItem(PENDING_GALLERY_QR_VISIT_KEY, normalizedToken);
    } else {
      window.sessionStorage.removeItem(PENDING_GALLERY_QR_VISIT_KEY);
    }
  } catch (_) {
    // A private browsing setting can block session storage. The gallery still opens normally.
  }
}
